/* STENS — Products data (embedded for file:// support) */
window.STENS_PRODUCTS_DATA = {
  "products": [
    {
      "id": "ST-2810",
      "name": "Street Coilover",
      "series": "street",
      "tag": "ST-2810",
      "tagline": "Height adjustable performance for daily driving.",
      "image": "assets/placeholders/product-coilover.svg",
      "gallery": [
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg"
      ],
      "specs": {
        "Drop": "10-40mm",
        "Spring rate": "60/80 N/mm",
        "Damper type": "Twin tube",
        "Adjustment": "30 steps",
        "Material": "54SiCr6 spring steel",
        "Weight": "12 kg / set"
      },
      "features": [
        "Height-adjustable threaded perch",
        "Comfort-tuned damping for daily driving",
        "TÜV-approved for European road use",
        "5-year limited warranty"
      ],
      "fitments": [
        {
          "make": "BMW",
          "model": "3 Series (E90)",
          "years": "2005-2012"
        },
        {
          "make": "BMW",
          "model": "3 Series (F30)",
          "years": "2012-2018"
        },
        {
          "make": "Audi",
          "model": "A4 (B8)",
          "years": "2008-2015"
        },
        {
          "make": "Mercedes-Benz",
          "model": "C-Class (W204)",
          "years": "2007-2014"
        }
      ],
      "warranty": "5 years / 100,000 km"
    },
    {
      "id": "ST-2825",
      "name": "Comfort Lowering",
      "series": "street",
      "tag": "ST-2825",
      "tagline": "25mm drop for refined city-friendly handling.",
      "image": "assets/placeholders/product-coilover.svg",
      "gallery": [
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg"
      ],
      "specs": {
        "Drop": "25mm fixed",
        "Spring rate": "55/75 N/mm",
        "Damper type": "OEM compatible",
        "Material": "54SiCr6 spring steel",
        "Weight": "4 kg / set"
      },
      "features": [
        "Direct OEM replacement",
        "Maintains stock damper compatibility",
        "Progressive spring rate",
        "Lifetime structural warranty"
      ],
      "fitments": [
        {
          "make": "BMW",
          "model": "3 Series (F30)",
          "years": "2012-2018"
        },
        {
          "make": "Audi",
          "model": "A3 (8V)",
          "years": "2013-2020"
        },
        {
          "make": "Honda",
          "model": "Civic Type R (FK8)",
          "years": "2017-2021"
        }
      ],
      "warranty": "Lifetime structural"
    },
    {
      "id": "ST-2835",
      "name": "Touring Set",
      "series": "street",
      "tag": "ST-2835",
      "tagline": "Long-distance comfort with sport-tuned damping.",
      "image": "assets/placeholders/product-coilover.svg",
      "gallery": [
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg"
      ],
      "specs": {
        "Drop": "20-30mm",
        "Spring rate": "50/70 N/mm",
        "Damper type": "Monotube",
        "Adjustment": "Height adjustable",
        "Material": "54SiCr6 spring steel",
        "Weight": "11 kg / set"
      },
      "features": [
        "Optimized for highway comfort",
        "Reduced NVH transfer",
        "Compatible with adaptive damping systems",
        "TÜV approved"
      ],
      "fitments": [
        {
          "make": "Mercedes-Benz",
          "model": "E-Class (W212)",
          "years": "2009-2016"
        },
        {
          "make": "Volvo",
          "model": "V60 Polestar",
          "years": "2014-2018"
        }
      ],
      "warranty": "5 years / 100,000 km"
    },
    {
      "id": "SP-3540",
      "name": "Sport Springs",
      "series": "sport",
      "tag": "SP-3540",
      "tagline": "40mm drop, increased spring rate.",
      "image": "assets/placeholders/product-spring.svg",
      "gallery": [
        "assets/placeholders/product-spring.svg",
        "assets/placeholders/product-spring.svg",
        "assets/placeholders/product-spring.svg"
      ],
      "specs": {
        "Drop": "40mm",
        "Spring rate": "75/95 N/mm",
        "Material": "54SiCr6 spring steel",
        "Surface": "Zinc-flake coated",
        "Weight": "5.5 kg / set"
      },
      "features": [
        "40mm aggressive drop",
        "Increased spring rate for sharper turn-in",
        "Compatible with OEM and aftermarket dampers",
        "Powder-coated finish"
      ],
      "fitments": [
        {
          "make": "Volkswagen",
          "model": "Golf (Mk7)",
          "years": "2012-2019"
        },
        {
          "make": "Audi",
          "model": "S3 (8V)",
          "years": "2014-2020"
        },
        {
          "make": "Honda",
          "model": "Civic Type R (FK8)",
          "years": "2017-2021"
        },
        {
          "make": "Subaru",
          "model": "WRX STI (VA)",
          "years": "2014-2021"
        }
      ],
      "warranty": "Lifetime structural"
    },
    {
      "id": "SP-3535",
      "name": "Track Springs",
      "series": "sport",
      "tag": "SP-3535",
      "tagline": "35mm drop with progressive rate.",
      "image": "assets/placeholders/product-spring.svg",
      "gallery": [
        "assets/placeholders/product-spring.svg",
        "assets/placeholders/product-spring.svg",
        "assets/placeholders/product-spring.svg"
      ],
      "specs": {
        "Drop": "35mm",
        "Spring rate": "Progressive 70-110 N/mm",
        "Material": "54SiCr6 spring steel",
        "Weight": "5.2 kg / set"
      },
      "features": [
        "Progressive rate for street + track use",
        "Linear initial response, firms up at limit",
        "Track-day approved",
        "TÜV approved"
      ],
      "fitments": [
        {
          "make": "BMW",
          "model": "M3 (F80)",
          "years": "2014-2018"
        },
        {
          "make": "Audi",
          "model": "RS3 (8V)",
          "years": "2017-2020"
        }
      ],
      "warranty": "Lifetime structural"
    },
    {
      "id": "SP-3550",
      "name": "Sport Coilover",
      "series": "sport",
      "tag": "SP-3550",
      "tagline": "Adjustable height and rebound damping.",
      "image": "assets/placeholders/product-coilover.svg",
      "gallery": [
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg"
      ],
      "specs": {
        "Drop": "20-50mm",
        "Spring rate": "80/100 N/mm",
        "Damper type": "Monotube",
        "Adjustment": "16-way rebound",
        "Material": "54SiCr6 spring steel",
        "Weight": "13 kg / set"
      },
      "features": [
        "16-position rebound adjustment",
        "Independent height adjustment",
        "Spherical bearing top mounts (front)",
        "Track-day approved"
      ],
      "fitments": [
        {
          "make": "Porsche",
          "model": "Cayman (981)",
          "years": "2013-2016"
        },
        {
          "make": "BMW",
          "model": "M3 (E92)",
          "years": "2008-2013"
        }
      ],
      "warranty": "3 years / 60,000 km"
    },
    {
      "id": "RC-4520",
      "name": "Race Sway Bar",
      "series": "race",
      "tag": "RC-4520",
      "tagline": "3-position adjustable, 28mm front.",
      "image": "assets/placeholders/product-swaybar.svg",
      "gallery": [
        "assets/placeholders/product-swaybar.svg",
        "assets/placeholders/product-swaybar.svg",
        "assets/placeholders/product-swaybar.svg"
      ],
      "specs": {
        "Diameter": "28mm front / 24mm rear",
        "Adjustment": "3 positions per axle",
        "Material": "Tubular chrome-moly",
        "Weight": "8.5 kg / set"
      },
      "features": [
        "3-position adjustable end links",
        "Tubular construction reduces unsprung weight",
        "Improves turn-in response",
        "Direct OEM bracket fitment"
      ],
      "fitments": [
        {
          "make": "Volkswagen",
          "model": "Golf (Mk7)",
          "years": "2012-2019"
        },
        {
          "make": "Subaru",
          "model": "WRX STI (VA)",
          "years": "2014-2021"
        }
      ],
      "warranty": "5 years"
    },
    {
      "id": "RC-4540",
      "name": "Track Spacers",
      "series": "race",
      "tag": "RC-4540",
      "tagline": "Hub-centric, 20mm forged spacers.",
      "image": "assets/placeholders/product-spacer.svg",
      "gallery": [
        "assets/placeholders/product-spacer.svg",
        "assets/placeholders/product-spacer.svg",
        "assets/placeholders/product-spacer.svg"
      ],
      "specs": {
        "Thickness": "20mm",
        "Material": "Forged 7075 aluminium",
        "Type": "Hub-centric",
        "Hardware": "Extended studs included",
        "Weight": "1.4 kg / pair"
      },
      "features": [
        "Forged 7075 aluminium",
        "Hub-centric for vibration-free fitment",
        "Extended ARP studs included",
        "Black anodized finish"
      ],
      "fitments": [
        {
          "make": "BMW",
          "model": "M3 (F80)",
          "years": "2014-2018"
        },
        {
          "make": "Porsche",
          "model": "911 (991)",
          "years": "2012-2018"
        },
        {
          "make": "Subaru",
          "model": "BRZ (ZD8)",
          "years": "2022-2024"
        }
      ],
      "warranty": "5 years"
    },
    {
      "id": "RC-4560",
      "name": "Race Coilover",
      "series": "race",
      "tag": "RC-4560",
      "tagline": "3-way adjustable monotube damper.",
      "image": "assets/placeholders/product-coilover.svg",
      "gallery": [
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg",
        "assets/placeholders/product-coilover.svg"
      ],
      "specs": {
        "Drop": "Track-tunable 20-80mm",
        "Spring rate": "100/140 N/mm",
        "Damper type": "Monotube, 50mm piston",
        "Adjustment": "3-way (compression/rebound)",
        "Material": "54SiCr6 + chrome-moly",
        "Weight": "14 kg / set"
      },
      "features": [
        "3-way adjustable damping",
        "External reservoir on rear units",
        "Spherical bearing top mounts",
        "Race-only (not TÜV approved)"
      ],
      "fitments": [
        {
          "make": "Porsche",
          "model": "911 (992)",
          "years": "2019-2024"
        },
        {
          "make": "BMW",
          "model": "M3 (F80)",
          "years": "2014-2018"
        },
        {
          "make": "Honda",
          "model": "Civic Type R (FK8)",
          "years": "2017-2021"
        },
        {
          "make": "Subaru",
          "model": "WRX STI (VA)",
          "years": "2014-2021"
        }
      ],
      "warranty": "1 year (race use)"
    }
  ]
};
